export type PerguntaItem = {
    localId: number
    id: number | null
    descricao: string
    ordem: number | null
    tipo: number
}

export type PerguntaPesquisaSatisfacaoModel = {
    perguntas: PerguntaItem[]
    pendingDelete: number[]
    _nextLocalId: number
}

export const PerguntaPesquisaSatisfacaoInicial: PerguntaPesquisaSatisfacaoModel = {
    perguntas: [],
    pendingDelete: [],
    _nextLocalId: 1,
}
